var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "m11.5 1.5 3 7h7l-5 5 2 8-7-5-7 5 2-8-5-5h7z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "5ab7ab15467134b5f27481efb61c4789.svg";